import React, {FC} from "react"
import styled, {css} from "styled-components"

import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import ToastAlert from "@irati/ui/src/ToastAlert"
import {triggerSuccessToast} from "@irati/ui/src/ToastAlert/triggerToast"
import FormattedMessage, {useIntl} from "@irati/utils/lang"

interface Props {
  onConfirm?: () => void
  confirmText?: string
  disabledSave?: boolean
  confirmLoad?: Promise<any> | null
}

const FooterFlex = styled(Flex)`
  height: 74px;
  position: fixed;
  left: 0;
  bottom: calc(0% + 32px);
  width: 100%;
  padding-right: 80px;
  background: ${({theme}) => theme.colors.greys.white};
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.desktop`
      display: none;
    `}
  `}
`

const SaveAndProgressFooter: FC<Props> = ({onConfirm, confirmText, disabledSave, confirmLoad}) => {
  const {formatMessage} = useIntl()
  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      triggerSuccessToast(formatMessage({id: "platform.selfSignUp.welcome.copyLinkMessage"}))
    })
  }

  return (
    <>
      <ToastAlert />
      <FooterFlex justifyContent="flex-end" gap={2} alignItems="center" padding="0 16px">
        <Button tertiary onClick={handleCopyLink}>
          <Icon icon={IconTypes.files} size={20} />
          <FormattedMessage id="platform.selfSignUp.welcome.popUp.copyLink" />
        </Button>

        {onConfirm && (
          <Button primary onClick={onConfirm} disabled={disabledSave} load={confirmLoad}>
            {confirmText}
          </Button>
        )}
      </FooterFlex>
    </>
  )
}

export default SaveAndProgressFooter
